<mat-dialog-content>
    <h2>Add Vehicle Group</h2>
    <form [formGroup]="vehicleGroupForm" (ngSubmit)="onSubmit()" autocomplete="off" fxLayout="column" fxLayoutAlign=" none">

        <mat-form-field appearance="fill">
            <mat-label>Input</mat-label>
            <input matInput formControlName="name">
        </mat-form-field>
        <div>
            <div fxLayout="row" fxLayoutAlign="space-between center">
                Models
                <button mat-button matSuffix mat-icon-button aria-label="Clear" color="danger" type="button"
                    (click)="addModel()"><mat-icon>add_circle</mat-icon></button>
            </div>
            <div *ngFor="let element of vehicleGroupForm.get('models').value; let i = index">
                <div fxLayout="row" fxLayoutAlign="space-between center">
                    <p>{{ element.id }} - {{ element.name }} </p>
                    <button mat-button matSuffix mat-icon-button aria-label="Clear" color="danger" type="button"
                        (click)="removeModel(i)"><mat-icon>remove_circle</mat-icon></button>
                </div>
                <div>
                    <span *ngFor="let model of element.vehicle_models">{{ model.name }},</span>
                </div>
                <hr>
            </div>
        </div>
        <button type="submit" mat-raised-button color="primary" [disabled]="!vehicleGroupForm.valid">Save</button>

    </form>
</mat-dialog-content>